import create from "zustand";

interface FiltroState {
  filtroExecucaoOPeracional: {
    safraPeriodos?: string[];
    operacoes?: {
      operacaoId: string;
      cor: string;
    }[] | null;
    datasProgramadas?: {
      dataProgramada?: string;
      color?: string;
    }[] | null;
    operacaoClasses?: {
      operacaoClasseId: string;
      cor: string;
    }[] | null;
    statusSemaforo?: {
      status: number;
      color: string;
    }[] | null;
  } | {}

   update: (value: any) => any;
}

const useModalSelecaoTalhoes = create<FiltroState>((set) => ({

  filtroExecucaoOPeracional: {},

  update: (filtroExecucaoOPeracional) => {
    set(state => ({ filtroExecucaoOPeracional }));
  },
  
  
}));

export default useModalSelecaoTalhoes;
